var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import LoadingSkeleton from "../LoadingSkeleton";
import { TEXT_COLOR_MAPPING } from "../../../constants";
import React from "react";
var Text = function (_a) {
    var children = _a.children, _b = _a.emphasis, emphasis = _b === void 0 ? "high" : _b, _c = _a.shade, shade = _c === void 0 ? "dark" : _c, _d = _a.category, category = _d === void 0 ? "primary" : _d, weight = _a.weight, _e = _a.family, family = _e === void 0 ? "primary" : _e, _f = _a.sx, sx = _f === void 0 ? {} : _f, _g = _a.loadingProps, loadingProps = _g === void 0 ? {} : _g, rest = __rest(_a, ["children", "emphasis", "shade", "category", "weight", "family", "sx", "loadingProps"]);
    var content = typeof children === "undefined" && !rest.dangerouslySetInnerHTML ? (_jsx(LoadingSkeleton, __assign({}, loadingProps))) : (children);
    return (_jsx(Typography, __assign({ sx: __assign(__assign({}, TEXT_COLOR_MAPPING["".concat(category, "-").concat(shade, "-").concat(emphasis)]), sx), style: __assign(__assign({}, (weight && { fontWeight: weight })), (family === "secondary" && { fontFamily: "Matter" })) }, rest, { children: content })));
};
export default React.memo(Text);
